export default function PDFSVG ({ width }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 100" width={width}>
            <defs>
                <linearGradient id="a" x1="105" x2="-80" y1="123" y2="-112" gradientTransform="translate(2 922.36)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#e6e6e6"/>
                    <stop offset="1" stopColor="#f9f9f9"/>
                </linearGradient>
                <linearGradient id="b" x1="93" x2="80" y1="944.36" y2="957.36" gradientTransform="translate(2 -2)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#ccc"/>
                    <stop offset=".22" stopColor="#e6e6e6"/>
                    <stop offset=".469" stopColor="#fff"/>
                    <stop offset="1" stopColor="#e6e6e6"/>
                </linearGradient>
            </defs>
            <g fillRule="evenodd" stroke="gray" strokeLinejoin="round">
                <path fill="url(#a)" d="M82 930.36H22v115h85v-90z" transform="matrix(.86046 0 0 .86207 -18.5 -801.602)"/>
                <path fill="url(#b)" d="m107 955.36-25-25c1.863 8.333 2.133 16.667 0 25 9.906-1.935 17.128-.568 25 0z" transform="matrix(.86046 0 0 .86207 -18.5 -801.602)"/>
            </g>
            <path fill="#a00" d="M1.942 34.378h70.116v31.256H1.942z"/>
            <text xmlSpace="preserve" x="29.899" y="983.973" fill="#fff" fontFamily="Sans" fontSize="24.549" letterSpacing="0" transform="translate(-17.305 -925.022)" wordSpacing="0">
        <tspan x="29.899" y="983.973">PDF</tspan>
      </text>
        </svg>
    );
}